export const SLICE_NAME = "chargers";
